import React from "react";

const MyWalletFavItem = () => {
    const walletItem = [1, 2, 3, 4];
    return (
        <>
            {
                walletItem.map((item, id) =>
                    <ul className="_fav_main_table_item_wrap">
                        <li className="_fav_main_table_item">
                            <input type="checkbox" name="favcheck" id={`favcheck${item}`} className="favcheck_main_in" />
                            <label htmlFor={`favcheck${item}`} className="_favcheck_label">
                                <img src={`assets/img/fav${item}.png`} alt="pic" className="_favcheck_label_img" />
                                <div className="_favcheck_label_right">
                                    <p className="_favcheck_label_right_name">Pixa Studio</p>
                                    <p className="_favcheck_label_right_owner">@pixastudio</p>
                                </div>
                            </label>
                        </li>
                        <li className="_fav_main_table_item">
                            <p className="_fav_main_table_item_num">Buy
                            </p>
                        </li>
                        <li className="_fav_main_table_item">
                            <span className="_fav_main_table_item_ic"><svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} fill="none" viewBox="0 0 15 15">
                                <g clipPath="url(#a)">
                                    <path fill="#35373E" fillRule="evenodd" d="M7.323 14.61 3.159 8.474l4.164 2.63 4.164-2.63-4.164 6.136Z" clipRule="evenodd" />
                                    <path fill="#35373E" fillRule="evenodd" d="M7.323 14.61v-3.507l4.164-2.63-4.164 6.137Zm0-13.806 4.164 7.012-4.164 2.63-4.164-2.63L7.323.804Z" clipRule="evenodd" />
                                    <path fill="#35373E" fillRule="evenodd" d="m7.323.804 4.164 7.012-4.164 2.63V.804Z" clipRule="evenodd" />
                                    <path fill="#35373E" fillRule="evenodd" d="m7.323.804 4.164 7.012-4.164-1.972V.804Z" clipRule="evenodd" />
                                    <path fill="#35373E" fillRule="evenodd" d="m11.487 7.816-4.164 2.63-4.164-2.63 4.164-1.972 4.164 1.972Z" clipRule="evenodd" />
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" d="M0 0h13.806v13.806H0z" transform="translate(.283 .805)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            </span>
                            <p className="_fav_main_table_item_num">1,1324.04 ETH</p>
                        </li>
                        <li className="_fav_main_table_item">
                            <p className="_fav_main_table_item_num">June 5, 08:22 PM</p>
                        </li>
                        <li className="_fav_main_table_item"> <button className="_stats_main_item_more_btn"><svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} fill="none" viewBox="0 0 26 26">
                            <path fill="#797A7E" d="M12.725 3.339a2.088 2.088 0 0 0-2.081 2.082c0 1.145.936 2.082 2.081 2.082a2.088 2.088 0 0 0 2.082-2.082 2.088 2.088 0 0 0-2.082-2.082Zm0 14.573a2.088 2.088 0 0 0-2.081 2.082c0 1.145.936 2.082 2.081 2.082a2.088 2.088 0 0 0 2.082-2.082 2.088 2.088 0 0 0-2.082-2.082Zm0-7.286a2.088 2.088 0 0 0-2.081 2.082c0 1.145.936 2.082 2.081 2.082a2.088 2.088 0 0 0 2.082-2.082 2.088 2.088 0 0 0-2.082-2.082Z" />
                        </svg>
                        </button></li>
                    </ul>
                )
            }
        </>
    )
}
export default MyWalletFavItem;